<form [formGroup]="aiEvaluatorForm" (ngSubmit)="onSubmitAiEvaluatorForm($event)">
  <div class="form-group mt-3" formGroupName="apiAddress">
    <label for="apiAddress">
      {{ 'Settings::AIEvaluator.ApiAddress' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="apiAddress"
      formControlName="value" />
  </div>
  <div class="form-group mt-3" formGroupName="identityBaseUrl">
    <label for="identityBaseUrl">
      {{ 'Settings::AIEvaluator.IdentityBaseUrl' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="identityBaseUrl"
      formControlName="value" />
  </div>
  <div class="form-group mt-3" formGroupName="clientId">
    <label for="clientId">
      {{ 'Settings::AIEvaluator.ClientId' | abpLocalization }}
    </label>
    <input type="text" class="form-control form-control-sm" id="clientId" formControlName="value" />
  </div>
  <div class="form-group mt-3" formGroupName="clientSecret">
    <label for="clientSecret">
      {{ 'Settings::AIEvaluator.ClientSecret' | abpLocalization }}
    </label>
    <input
      type="password"
      class="form-control form-control-sm"
      id="clientSecret"
      formControlName="value"
      [placeholder]="'Settings::MaskedAreaPlaceholder' | abpLocalization" />
  </div>
  <div class="form-group mt-3" formGroupName="project">
    <label for="project">
      {{ 'Settings::AIEvaluator.Project' | abpLocalization }}
    </label>
    <input type="text" class="form-control form-control-sm" id="project" formControlName="value" />
  </div>
  <div>
    <button
      type="button"
      type="submit"
      class="btn btn-primary mt-3"
      [disabled]="!aiEvaluatorForm.valid">
      <i class="me-1 fas fa-save"></i>
      {{ 'AbpUi::Save' | abpLocalization }}
    </button>
  </div>
</form>
